const BASE_URL = "https://fullstack-crud-react-spring.onrender.com";

export default BASE_URL;
